export default {
    fsmRoute_modal_editCreate_create: "Rutas",
    fsmRoute_modal_editCreate_edit: "Editar Ruta",
    fsmRoute_modal_editCreate_error_name: "El nombre de la ruta ya existe.",
    fsmRoute_modal_editCreate_error_incorrect_route: "El punto que está intentando crear se encuentra en una ubicación no válida, por favor, vuelva a colocar el punto en una ubicación válida para la ruta.",
}